import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56e66743"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tab-panel-context"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "flow-line"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名：", -1));
const _hoisted_5 = {
  class: "flow-line"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "手机号：", -1));
const _hoisted_7 = {
  key: 1,
  class: "tow-rows"
};
const _hoisted_8 = {
  key: 2,
  class: "tow-rows"
};
const _hoisted_9 = {
  key: 3,
  class: "tow-rows"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Empty = _resolveComponent("Empty");
  const _component_a_table = _resolveComponent("a-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
    dataSource: _ctx.data,
    columns: _ctx.columns,
    pagination: false,
    scroll: {
      y: 550,
      x: 'auto'
    }
  }, {
    bodyCell: _withCtx(({
      column,
      record
    }) => [column.key === 'contactPersonName' ? (_openBlock(), _createElementBlock("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(record.contactPersonName), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(record.contactPersonPhone), 1)])])) : _createCommentVNode("", true), column.key === 'exceptionRemark' ? (_openBlock(), _createElementBlock("section", _hoisted_7, _toDisplayString(record.exceptionRemark), 1)) : _createCommentVNode("", true), column.key === 'replyRemark' ? (_openBlock(), _createElementBlock("section", _hoisted_8, _toDisplayString(record.replyRemark), 1)) : _createCommentVNode("", true), column.key === 'shipmentComplaintStatus' ? (_openBlock(), _createElementBlock("section", _hoisted_9, _toDisplayString(record.shipmentComplaintStatus === 10 ? '处理中' : '已处理'), 1)) : _createCommentVNode("", true)]),
    emptyText: _withCtx(() => [_createVNode(_component_Empty, {
      class: "empty-context"
    })]),
    _: 1
  }, 8, ["dataSource", "columns"])]);
}